import { FuelTypography } from '@frete.com/fuel-react';
import { FC, useMemo } from 'react';

import { Feature } from '@/components';
import { useLearnMoreModal, usePrice } from '@/hooks';
import { LearnMoreModalList } from '@/pages';

import { Container } from './styled';

export const COST_TEXT =
  'Depois dos 15 dias gratuitos, só pague se o motorista for aprovado: :registerPrice por cadastro e :queryPrice por consulta.';

export const FeatureList: FC = () => {
  const learnMoreModal = useLearnMoreModal();
  const { queryPrice, registerPrice } = usePrice();

  const costText = useMemo(
    () => COST_TEXT.replace(':registerPrice', registerPrice).replace(':queryPrice', queryPrice),
    [registerPrice, queryPrice]
  );

  return (
    <>
      <Container>
        <Feature icon="one-check" title="Aceita pelas seguradoras" learnMoreAction={() => learnMoreModal.open(0)}>
          <FuelTypography size="body-md" weight="regular" color="neutral-strong">
            Validações feitas pela{' '}
            <FuelTypography displayInline weight="bold">
              Skymark
            </FuelTypography>
            , homologada por todas seguradoras.
          </FuelTypography>
          <FuelTypography size="body-md" weight="regular" color="neutral-strong">
            Novas GRs em breve.
          </FuelTypography>
        </Feature>
        <Feature icon="clock" title="Mais rápida" learnMoreAction={() => learnMoreModal.open(1)}>
          <FuelTypography size="body-md" weight="regular" color="neutral-strong">
            Dados pré-preenchido por mais de 800mil motoristas Fretebras. Retorno imediato para consultas e em até{' '}
            <FuelTypography displayInline weight="bold">
              30 min
            </FuelTypography>{' '}
            para cadastros.
          </FuelTypography>
        </Feature>
        <Feature icon="shield" title="Mais segura" learnMoreAction={() => learnMoreModal.open(2)}>
          <FuelTypography size="body-md" weight="regular" color="neutral-strong">
            Além dos padrões das GRs de mercado, temos uma camada adicional de segurança utilizando inteligência
            artificial.
          </FuelTypography>
        </Feature>
        <Feature icon="money" title="Redução de custos">
          <FuelTypography size="body-md" weight="regular" color="neutral-strong">
            {costText}
          </FuelTypography>
        </Feature>
      </Container>
      <LearnMoreModalList />
    </>
  );
};
